/* RumPumBumm product page (2026-09-28): the approved prototype's behaviour (design/product-v2.js)
   on the store's data, which sections/rpb-main-product.liquid renders into the page. The section
   draws the first view; this script redraws the parts a colour, plate design or quantity
   changes, with the prototype's own markup. Cart: Dawn's drawer via window.rpbAddToCart
   (assets/rpb-site.js); Buy It Now: a cart link straight to checkout with just this selection.
   A gift note (gift sets) rides on the main line as a property, in both. */
(() => {
  'use strict';
  const MAX_QUANTITY = 10;
  const money = (paise) => window.rpbMoney(paise); // defined in rpb-site.js from the store's currency format
  const esc = (value) => String(value ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);
  const CART_ICON = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M2.5 3.5h2.3l2.3 11a1.8 1.8 0 0 0 1.8 1.4h8.4a1.8 1.8 0 0 0 1.7-1.3l1.8-6.8H5.8"/><circle cx="9.6" cy="20.2" r="1.4"/><circle cx="17.4" cy="20.2" r="1.4"/></svg>';
  const CHEVRON = ['<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m15 5-7 7 7 7"/></svg>', '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m9 5 7 7-7 7"/></svg>'];

  function init(wrapper) {
    if (!wrapper || wrapper.dataset.ready) return;
    wrapper.dataset.ready = '1';
    const data = JSON.parse(wrapper.querySelector('[data-rpb-pdp-data]').textContent);
    const $ = (selector) => wrapper.querySelector(selector);
    const gallery = $('#pdp-gallery');
    const dock = document.getElementById('dock');
    const note = $('[data-gift-note]');
    const state = { colour: data.colour, design: data.design, quantity: 1, shots: [] };

    const matches = (variant, colour, design) => (data.ci < 0 || variant.options[data.ci] === colour) && (data.di < 0 || variant.options[data.di] === design);
    const selected = () => data.variants.find((variant) => matches(variant, state.colour, state.design)) || data.variants[0];
    // What the buttons put in the cart: the chosen variant, with the gift note if one is written.
    function selectionItems() {
      const main = { id: selected().id, quantity: state.quantity };
      if (note && note.value.trim()) main.properties = { [note.dataset.giftNote]: note.value.trim() };
      return [main];
    }

    function shotsFor() {
      const shots = selected().shots.map((shot) => ({ ...shot }));
      for (const piece of data.pieces) {
        const shot = piece.plate ? (data.plates[state.design] || {})[state.colour] : piece.shots[state.colour];
        if (shot && shot.src) shots.push({ src: shot.src, thumb: shot.thumb, alt: `In the set: ${shot.alt || ''}` });
      }
      // Photos whose description names no colour show for every colour, last (2026-10-06).
      for (const shot of data.sharedShots || []) shots.push({ ...shot });
      return shots;
    }

    // Photos (prototype renderGallery): one swipeable track, arrows on hover, thumbnails beside it
    // and dots under it on phones; they all scroll the track itself, never the page.
    let shotIndex = 0;
    function renderGallery() {
      state.shots = shotsFor();
      shotIndex = 0;
      const many = state.shots.length > 1;
      const stage = gallery.querySelector('.pdp-stage');
      const keep = [...stage.children].filter((child) => child.matches('.save-tag, .wish-toggle')).map((child) => child.outerHTML).join('');
      gallery.classList.toggle('has-rail', many);
      const photos = state.shots.map((shot, index) => `<img${index ? ' loading="lazy"' : ' id="pdp-photo"'} src="${esc(shot.src)}" alt="${esc(shot.alt)}" width="1000" height="1000">`).join('');
      const controls = many ? `<button type="button" class="gal-arrow" data-gal-step="-1" aria-label="Previous image">${CHEVRON[0]}</button><button type="button" class="gal-arrow" data-gal-step="1" aria-label="Next image">${CHEVRON[1]}</button>` : '';
      const dots = many ? `<div class="gal-dots">${state.shots.map((shot, index) => `<button type="button" class="gal-dot" data-shot="${index}" aria-label="Show image ${index + 1} of ${state.shots.length}" aria-current="${index === 0}"></button>`).join('')}</div>` : '';
      const rail = many ? `<div class="pdp-rail">${state.shots.map((shot, index) => `<button type="button" class="pdp-thumb" data-shot="${index}" aria-label="Show image ${index + 1} of ${state.shots.length}" aria-current="${index === 0}"><img src="${esc(shot.thumb || shot.src)}" alt="" width="1000" height="1000" loading="lazy"></button>`).join('')}</div>` : '';
      gallery.innerHTML = `<div class="pdp-stage"><div class="pdp-slides" tabindex="0" role="region" aria-label="Product images, ${state.shots.length} in all">${photos}</div>${keep}${controls}</div>${dots}${rail}`;
      if (window.rpbPaintWish) window.rpbPaintWish();
      syncGallery();
    }
    function showShot(index) {
      const track = gallery.querySelector('.pdp-slides');
      shotIndex = Math.max(0, Math.min(state.shots.length - 1, index));
      track.scrollTo({ left: shotIndex * track.clientWidth, behavior: 'smooth' });
      syncGallery();
    }
    function syncGallery() {
      gallery.querySelectorAll('[data-shot]').forEach((item) => item.setAttribute('aria-current', String(Number(item.dataset.shot) === shotIndex)));
      const prev = gallery.querySelector('[data-gal-step="-1"]'), next = gallery.querySelector('[data-gal-step="1"]');
      if (prev) prev.disabled = shotIndex === 0;
      if (next) next.disabled = shotIndex === state.shots.length - 1;
      const thumb = gallery.querySelector(`.pdp-thumb[data-shot="${shotIndex}"]`);
      if (!thumb) return;
      // Scroll the thumbnail rail itself, on whichever axis it overflows, never the page.
      const rail = thumb.parentElement;
      rail.scrollTo({ top: thumb.offsetTop - (rail.clientHeight - thumb.offsetHeight) / 2, left: thumb.offsetLeft - (rail.clientWidth - thumb.offsetWidth) / 2, behavior: 'smooth' });
    }

    function renderOptions() {
      const colours = data.ci < 0 ? '' : `<fieldset class="pdp-colours"><legend>${esc(data.optionNames[0])}: <span id="colour-name">${esc(state.colour)}</span></legend><div class="swatches">${data.colours.map((colour) => `<label class="swatch" title="${esc(colour.name)}"><input type="radio" name="colour" value="${esc(colour.name)}"${colour.name === state.colour ? ' checked' : ''}><span class="swatch-chip" style="--chip:${esc(colour.hex)}"></span><span class="sr-only">${esc(colour.name)}</span></label>`).join('')}</div></fieldset>`;
      const designs = data.di < 0 ? '' : `<fieldset class="pdp-designs"><legend>${esc(data.optionNames[1])}: <span id="design-name">${esc(state.design)}</span></legend><div class="design-tiles">${data.designs.map((design) => {
        const plate = (data.plates[design] || {})[state.colour];
        return `<label class="design-tile"><input type="radio" name="design" value="${esc(design)}"${design === state.design ? ' checked' : ''}><span class="design-photo">${plate && plate.thumb ? `<img src="${esc(plate.thumb)}" alt="" width="1000" height="1000">` : ''}</span><span>${esc(design)}</span></label>`;
      }).join('')}</div></fieldset>`;
      $('#pdp-options').innerHTML = colours + designs;
    }

    function renderPrice() {
      const variant = selected();
      const deal = variant.compare > variant.price;
      const now = `<strong${deal ? ' class="deal"' : ''}>${money(variant.price)}</strong>`;
      $('#pdp-price').innerHTML = (deal ? `${now}<del><span class="sr-only">MRP </span>${money(variant.compare)}</del><span class="pdp-saving">You save ${money(variant.compare - variant.price)}</span>` : now);
      const available = variant.available;
      const add = $('#pdp-add'), buy = $('#pdp-buy');
      add.disabled = buy.disabled = !available;
      add.textContent = available ? data.addLabel : 'Sold out';
    }

    function renderDock() {
      if (!dock) return;
      const variant = selected(), available = variant.available;
      const total = variant.price * state.quantity, saved = Math.max(0, variant.compare - variant.price) * state.quantity;
      dock.innerHTML = `<div class="dock-text"><p class="price"><span class="dock-label">Total</span><strong>${money(total)}</strong></p>${saved > 0 ? `<p class="dock-save">You save ${money(saved)}</p>` : ''}</div><button type="button" class="pill dark" data-buy="add"${available ? '' : ' disabled'}>${CART_ICON}${!available ? 'Sold out' : state.quantity > 1 ? `Add ${state.quantity} to Cart` : esc(data.addLabel)}</button>`;
    }
    function renderCare() {
      const care = $('#pdp-care');
      if (!care || !data.pieces.length) return;
      care.innerHTML = `<p>${esc(data.care).split('\n').join('</p><p>')}${data.careDesign && state.design === data.careDesign ? ` ${esc(data.careDesignNote)}` : ''}</p>`;
    }

    function renderSpecs() {  // a set's size list shows the chosen plate design's plate
      for (const item of document.querySelectorAll('[data-spec-design]')) item.hidden = item.dataset.specDesign !== state.design;
    }

    // Everything that depends on the colour or plate design.
    function render() {
      try { const url = new URL(location.href); url.searchParams.set('variant', selected().id); history.replaceState(history.state, '', url); } catch {}
      renderPrice();
      renderOptions();
      renderGallery();
      renderCare();
      renderSpecs();
      renderDock();
    }
    function setQuantity(quantity) {
      state.quantity = Math.min(MAX_QUANTITY, Math.max(1, quantity));
      $('#qty-value').textContent = state.quantity;
      $('[data-step="-1"]').disabled = state.quantity === 1;
      $('[data-step="1"]').disabled = state.quantity === MAX_QUANTITY;
      renderDock();
    }

    gallery.addEventListener('click', (event) => {
      const thumb = event.target.closest('[data-shot]');
      if (thumb) showShot(Number(thumb.dataset.shot));
      const step = event.target.closest('[data-gal-step]');
      if (step) showShot(shotIndex + Number(step.dataset.galStep));
    });
    // A swipe (or trackpad scroll) settles on a photo: follow it with the thumbnails and arrows.
    gallery.addEventListener('scroll', (event) => {
      if (!event.target.matches || !event.target.matches('.pdp-slides')) return;
      const index = Math.round(event.target.scrollLeft / event.target.clientWidth);
      if (index !== shotIndex) { shotIndex = index; syncGallery(); }
    }, { capture: true, passive: true });
    $('#pdp-options').addEventListener('change', (event) => {
      const name = event.target.name;
      if (name === 'colour') state.colour = event.target.value;
      if (name === 'design') state.design = event.target.value;
      render();
      const again = $(`#pdp-options input[name="${name}"]:checked`);
      if (again) again.focus();
    });
    // The gift note: its counter, and the card in How Your Gift Arrives that shows it.
    const showNote = () => {
      $('[data-note-count]').textContent = `${note.value.length}/${note.maxLength}`;
      document.querySelectorAll('[data-gift-note-preview]').forEach((card) => { card.textContent = note.value; });
    };
    if (note) {
      note.addEventListener('input', showNote);
      showNote();
      wrapper.addEventListener('click', (event) => {
        if (!event.target.closest('[data-gift-write]')) return;
        note.scrollIntoView({ block: 'center', behavior: 'smooth' });
        setTimeout(() => note.focus({ preventScroll: true }), 400);
      });
    }
    // The gift sections (how it arrives, its moments) play once they scroll into view.
    const still = matchMedia('(prefers-reduced-motion: reduce)').matches;
    wrapper.querySelectorAll('[data-gift-anim]').forEach((part) => {
      if (still) return;
      part.classList.add('gift-anim');
      new IntersectionObserver((entries, io) => entries.forEach((e) => { if (e.isIntersecting) { part.classList.add('is-in'); io.disconnect(); } }), { threshold: 0.25 }).observe(part);
    });
    $('.qty').addEventListener('click', (event) => {
      const step = event.target.closest('[data-step]');
      if (step) setQuantity(state.quantity + Number(step.dataset.step));
    });
    const add = (button) => window.rpbAddToCart && window.rpbAddToCart(selectionItems(), button).catch(() => {});
    $('#pdp-add').addEventListener('click', (event) => add(event.currentTarget));
    // Razorpay Magic Checkout (snippets/razorpay-magic-checkout, 2026-10-13): live only when its script loaded and
    // its config says so (same test as YCM). Its modal is mounted hidden at load, so "open" = displayed.
    const magicLive = () => {
      if (typeof window.openRzpCheckout !== 'function') return false;
      try { return ((JSON.parse(document.getElementById('RazorpayMagicCheckoutConfig').textContent).config || {}).productConfig || {}).status === 'live'; } catch { return false; }
    };
    const magicOpen = () => { const box = document.querySelector('.razorpay-container'); return !!box && getComputedStyle(box).display !== 'none'; };
    $('#pdp-buy').addEventListener('click', async (event) => {
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const items = selectionItems();
      // With Magic: this selection joins the cart and Magic checks the cart out; Shopify's checkout if it never opens.
      if (magicLive()) {
        const button = event.currentTarget;
        button.disabled = true;
        try {
          const added = await fetch(`${root}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
          if (!added.ok) throw new Error('add');
          window.openRzpCheckout();
          let waited = 0;
          const poll = setInterval(() => {
            if (magicOpen()) { clearInterval(poll); button.disabled = false; }
            else if ((waited += 250) >= 4000) { clearInterval(poll); window.location.href = `${root}checkout`; }
          }, 250);
          return;
        } catch { button.disabled = false; }
      }
      // A cart link carries the first line's properties as base64url JSON (Shopify cart permalinks).
      const props = items[0].properties ? '?properties=' + btoa(String.fromCharCode(...new TextEncoder().encode(JSON.stringify(items[0].properties)))).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '') : '';
      window.location.href = `${root}cart/${items.map((item) => `${item.id}:${item.quantity}`).join(',')}${props}`;
    });
    if (dock) dock.addEventListener('click', (event) => { const button = event.target.closest('[data-buy="add"]'); if (button) add(button); });

    // The bar shows while the main buttons are off screen, and hides near the footer.
    let actionsInView = true, footerNear = false;
    const syncDock = () => {
      const open = !actionsInView && !footerNear;
      if (dock) dock.classList.toggle('is-open', open);
      document.body.classList.toggle('dock-open', open);
    };
    new IntersectionObserver(([entry]) => { actionsInView = entry.isIntersecting; syncDock(); }).observe($('#pdp-actions'));
    const footer = document.querySelector('.footer');
    if (footer) new IntersectionObserver(([entry]) => { footerNear = entry.isIntersecting; syncDock(); }, { rootMargin: '0px 0px 100px 0px' }).observe(footer);

    state.shots = shotsFor();
    syncGallery();
  }

  const start = () => document.querySelectorAll('[data-rpb-pdp]').forEach(init);
  document.addEventListener('shopify:section:load', start);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
